(function () {
  var existing = window.__vanemarHeroMedia;
  if (existing) {
    existing.init(document);
    return;
  }

  var selector = '[data-hero-media]';

  // The hero photo sits underneath the clip and is the poster, so refusing to
  // hydrate on a slow link costs nothing visually — the section still paints a
  // full-bleed background, just a still one.
  function allowsVideo() {
    return window.VMConnection ? window.VMConnection.allowsVideo() : true;
  }

  function initRoot(section) {
    if (!section || section.dataset.heroMediaInit === 'true') return;
    section.dataset.heroMediaInit = 'true';

    var cleanup = [];
    var reduceQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduceMotion = !!(reduceQuery && reduceQuery.matches);
    var animateReveal = !reduceMotion && !section.classList.contains('hero-media--no-reveal');
    var items = section.querySelectorAll('.heromedia-item');

    if (items.length && animateReveal && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          Array.prototype.forEach.call(items, function (item, index) {
            var timer = window.setTimeout(function () {
              item.style.transition = 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, index * 180);
            cleanup.push(function () { window.clearTimeout(timer); });
          });
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      revealObserver.observe(section);
      cleanup.push(function () { revealObserver.disconnect(); });
    } else if (items.length) {
      Array.prototype.forEach.call(items, function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });
    }

    // Sayfa içi (#…) CTA'lar hedef bölüme yumuşakça iner. Sabit header payı
    // html'deki scroll-padding-top: var(--header-h) üzerinden gelir; burada
    // ayrıca ofset eklemek onu çift sayar.
    function onAnchorClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href^="#"]');
      if (!link || !section.contains(link)) return;
      var hash = link.getAttribute('href');
      if (hash.length < 2) return;
      var target;
      try {
        target = document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (e) {
        return;
      }
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', hash);
    }
    section.addEventListener('click', onAnchorClick);
    cleanup.push(function () { section.removeEventListener('click', onAnchorClick); });

    // Kaydırma göstergesi hero'dan sonraki ilk bölüme iner. Hedef sabit bir
    // çapa değil, DOM'daki bir sonraki görünür bölüm: şablonda bölüm sırası
    // değişince de doğru yere gider. Header payı html'deki
    // scroll-padding-top: var(--header-h) üzerinden gelir.
    var scrollBtn = section.querySelector('[data-hero-scroll-next]');
    if (scrollBtn) {
      var onScrollNext = function () {
        var block = section.closest('.shopify-section') || section;
        var next = block.nextElementSibling;
        while (next && (next.offsetParent === null || next.getBoundingClientRect().height < 1)) {
          next = next.nextElementSibling;
        }
        if (next) {
          next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        // Son bölümse bir ekran aşağı in: düğme hiçbir koşulda ölü kalmasın.
        window.scrollBy({ top: window.innerHeight, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      scrollBtn.addEventListener('click', onScrollNext);
      cleanup.push(function () { scrollBtn.removeEventListener('click', onScrollNext); });
    }

    var video = section.querySelector('[data-hero-deferred-video]');
    if (!video) {
      section.__heroMediaCleanup = cleanup;
      return;
    }

    var fallbackImage = section.querySelector('[data-vm-video-fallback]');
    if (fallbackImage) {
      var onFallbackLoad = function () {
        if (fallbackImage.naturalWidth) section.setAttribute('data-hero-fallback-ready', 'true');
      };
      fallbackImage.addEventListener('load', onFallbackLoad);
      if (fallbackImage.complete) onFallbackLoad();
      cleanup.push(function () {
        fallbackImage.removeEventListener('load', onFallbackLoad);
        section.removeAttribute('data-hero-fallback-ready');
      });
    }

    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    var mobileQuery = window.matchMedia && window.matchMedia('(max-width: 767px)');
    var hideVideoOnMobile = section.getAttribute('data-hide-video-mobile') === 'true';
    var idleReady = false;
    var nearViewport = false;
    var videoSources = Array.prototype.map.call(video.querySelectorAll('source[data-src]'), function (source) {
      return { element: source, desktop: source.getAttribute('data-src') };
    });

    function videoAllowed() {
      return !(hideVideoOnMobile && mobileQuery && mobileQuery.matches);
    }

    // Telefonda 16:9 zemin klibinin yalnız orta şeridi görünüyor, o yüzden aynı
    // klibin daha küçük kopyası yeterli. data-src-mobile varsa (video-sources'a
    // mobile_max_height verildiğinde çıkar) hidratlamadan ÖNCE data-src'nin
    // yerine geçer; böylece kapının promote ettiği tek URL doğru olan olur ve
    // hiçbir bayt iki kez inmez.
    function pickVideoRendition() {
      var isMobile = mobileQuery && mobileQuery.matches;
      videoSources.forEach(function (source) {
        var mobile = isMobile && source.element.getAttribute('data-src-mobile');
        source.element.setAttribute('data-src', mobile || source.desktop);
      });
    }

    function hydrateVideo() {
      if (video.dataset.heroHydrated === 'true') return true;
      // A slow connection can unload the sources after the first play. Keep
      // the original desktop URL so recovery after a resize picks correctly.
      pickVideoRendition();
      if (window.VMConnection && window.VMConnection.hydrateVideo) {
        if (!window.VMConnection.hydrateVideo(video)) return false;
        video.dataset.heroHydrated = 'true';
        return true;
      }
      Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
        source.src = source.getAttribute('data-src');
      });
      video.dataset.heroHydrated = 'true';
      video.load();
      return true;
    }

    function startVideo() {
      if (!idleReady || !nearViewport || !videoAllowed() || reduceMotion || !allowsVideo() || document.hidden) return;
      if (!hydrateVideo()) return;
      var attempt = window.VMConnection && window.VMConnection.playVideo
        ? window.VMConnection.playVideo(video)
        : video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    function onPlaying() {
      video.classList.add('is-ready');
    }
    video.addEventListener('playing', onPlaying, { once: true });
    cleanup.push(function () { video.removeEventListener('playing', onPlaying); });

    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        nearViewport = !!(entries[0] && entries[0].isIntersecting);
        if (nearViewport) startVideo();
        else video.pause();
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      videoObserver.observe(section);
      cleanup.push(function () { videoObserver.disconnect(); });
    } else {
      nearViewport = true;
    }

    function markIdleReady() {
      var ready = function () {
        idleReady = true;
        startVideo();
      };
      if ('requestIdleCallback' in window) {
        var idleId = window.requestIdleCallback(ready, { timeout: 2000 });
        cleanup.push(function () { if (window.cancelIdleCallback) window.cancelIdleCallback(idleId); });
      } else {
        var timerId = window.setTimeout(ready, 1200);
        cleanup.push(function () { window.clearTimeout(timerId); });
      }
    }

    function onLoad() {
      markIdleReady();
    }
    if (document.readyState === 'complete') markIdleReady();
    else {
      window.addEventListener('load', onLoad, { once: true });
      cleanup.push(function () { window.removeEventListener('load', onLoad); });
    }

    function onVisibilityChange() {
      if (document.hidden) video.pause();
      else startVideo();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    cleanup.push(function () { document.removeEventListener('visibilitychange', onVisibilityChange); });

    if (window.VMConnection) {
      cleanup.push(window.VMConnection.subscribe(function (allowed) {
        if (allowed) startVideo();
        else video.pause();
      }));
    }

    function onMotionChange(event) {
      reduceMotion = event.matches;
      if (reduceMotion) video.pause();
      else startVideo();
    }
    if (reduceQuery) {
      if (reduceQuery.addEventListener) reduceQuery.addEventListener('change', onMotionChange);
      else if (reduceQuery.addListener) reduceQuery.addListener(onMotionChange);
      cleanup.push(function () {
        if (reduceQuery.removeEventListener) reduceQuery.removeEventListener('change', onMotionChange);
        else if (reduceQuery.removeListener) reduceQuery.removeListener(onMotionChange);
      });
    }

    function onBreakpointChange() {
      if (videoAllowed()) startVideo();
      else video.pause();
    }
    if (mobileQuery) {
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
      else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);
      cleanup.push(function () {
        if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', onBreakpointChange);
        else if (mobileQuery.removeListener) mobileQuery.removeListener(onBreakpointChange);
      });
    }

    cleanup.push(function () { video.pause(); });
    section.__heroMediaCleanup = cleanup;
  }

  function init(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(selector)) initRoot(scope);
    scope.querySelectorAll(selector).forEach(initRoot);
  }

  function destroy(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) roots.unshift(scope);
    roots.forEach(function (section) {
      (section.__heroMediaCleanup || []).forEach(function (dispose) { dispose(); });
      section.__heroMediaCleanup = null;
      delete section.dataset.heroMediaInit;
    });
  }

  window.__vanemarHeroMedia = { init: init, destroy: destroy };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
})();
